import * as React from "react";
import { useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { Button, DialogActions } from "@mui/material";
import LoadingAnimation from "../loading-animation";
import { ApiUrl } from "../API";
import { MyContext } from "../Context";
export default function CountrySelect({ handelform, cancelhandel }) {
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [companyArr, setcompanyArr] = useState([]);
  const [fieldval, setfieldval] = useState(undefined);
  const [showloader, setshowloader] = useState(false);
  const { sharedData, setSharedData, countdata } = useContext(MyContext);
  useEffect(() => {
    if (fieldval) {
      countdata.current = countdata.current + 1;
    }
  }, [fieldval]);
  useEffect(() => {
    if(query.length < 4){
      setcompanyArr([]);
    }
    const timer = setTimeout(() => {
      setDebouncedQuery(query); // Update debounced query after delay
    }, 1000); // 500ms debounce time

    return () => clearTimeout(timer); // Cleanup previous timeout
  }, [query]); // Runs only when query changes

  useEffect(() => {
    if (debouncedQuery && debouncedQuery.length > 3) {
      fetchData(debouncedQuery);
    }
  }, [debouncedQuery]); // Runs when debounced query updates
  const fetchData = async (searchTerm) => {
    setshowloader(true);
    axios
      .post(
        `${ApiUrl.ElasticSearch}`,
        {
          size: 10000,
          query: {
            query_string: {
              query: `${searchTerm}*`,
            },
          },
        },
        {
          headers: {
            Authorization: `${sessionStorage.getItem("CORESESSION")}`,
          },
        }
      )
      .then((resp) => {
        let modifydata = resp.data.hits.hits.map((res) => {
          return res["_source"];
        });
        setcompanyArr([]);
        setcompanyArr(modifydata);
      })
      .finally(() => {
        setshowloader(false);
      });
  };
  const cancelfn = () => {
    setcompanyArr([]);
    cancelhandel();
  };
  const confirm = () => {
    handelform(fieldval);
  };
  return (
    <div className="autocompletecls">
      <Autocomplete
        id="country-select-demo"
        sx={{ width: "90%", height: "80px" }}
        clearOnBlur={false}
        options={companyArr}
        autoHighlight
        getOptionLabel={(option) => option.Name}
        onChange={(event, newValue) => setfieldval(newValue)}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ padding: "10px" }}
              {...optionProps}
            >
              {option["Name"]}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select a Organisation"
            placeholder="Enter Organisation Name" //
            onInput={(e) => setQuery(e.target.value)}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password", // disable autocomplete and autofill
              },
            }}
          />
        )}
      />
      <DialogActions>
        <Button autoFocus onClick={cancelfn}>
          Cancel
        </Button>
        <Button onClick={confirm} disabled={!fieldval}>
          Ok
        </Button>
      </DialogActions>
      {showloader ? <LoadingAnimation /> : null}
    </div>
  );
}
